import { Box } from "@mui/material";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";

interface NursesWeekNominationBannerProps {
  onClick: () => void;
}

export function NursesWeekNominationBanner(props: NursesWeekNominationBannerProps) {
  const { onClick } = props;

  return (
    <Box>
      <PromotionBanner
        title="Nurses Week Nomination"
        subtitle="We are collecting real stories of excellent Nurses. Selected Nurses will be celebrated with gifts and recognition!"
        icon="star-filled"
        borderVariant="none"
        backgroundColor={(theme) => {
          const dayColor = theme.palette.shift?.day.gradient ?? theme.palette.info.light;
          const whiteColor = theme.palette.background.tertiary ?? theme.palette.common.white;
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- orange gradient fading to white matching Day shift icon
          return `linear-gradient(to right, ${dayColor}, ${whiteColor})`;
        }}
        ctaButtonText="Learn more"
        sx={{
          height: "100%",
          "& svg": {
            alignSelf: "flex-start",
          },
        }}
        onClick={onClick}
      />
    </Box>
  );
}
